import React, { useState, useEffect } from "react";
import { WeatherDataContext } from "./context";

import { getWeatherData } from "../services/services";

const WeatherProvider = ({ children }) => {
  const [WeatherData, setWeatherData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWeather = async () => {
      const Weather = await getWeatherData({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });
      setWeatherData(Weather);
    };

    fetchWeather();
  }, []);

  return (
    <WeatherDataContext.Provider
      value={{ WeatherData, setWeatherData, loading, error }}
    >
      {children}
    </WeatherDataContext.Provider>
  );
};

export default WeatherProvider;
